import { IntlShape } from "react-intl";

export const getMainFilterTerritoryManagerOptions = (intl: IntlShape) => [
  { value: "name", label: intl.formatMessage({ id: "usAdmin.name" }) },
  { value: "email", label: intl.formatMessage({ id: "usAdmin.email" }) },
];

export const TERRITORY_MANAGER_TABLE = {
  MOBILE_ROWS: 10,
  MOBILE_COLUMNS: 1,
  DESKTOP_ROWS: 10,
  DESKTOP_COLUMNS: 2,
};

export const TERRITORY_MANAGER_SORT_KEYS = {
  NAME: "name",
  EMAIL: "email",
};
